import { capSQLiteVersionUpgrade } from '@capacitor-community/sqlite';

export const OFFLINE_DATABASE_VERSION = 3;

export const OFFLINE_DATABASE_MIGRATIONS: capSQLiteVersionUpgrade[] = [
  {
    toVersion: 1,
    statements: [
      `CREATE TABLE IF NOT EXISTS app_metadata (
        key TEXT PRIMARY KEY NOT NULL,
        value TEXT,
        updated_at TEXT NOT NULL
      );`,
      `CREATE TABLE IF NOT EXISTS sync_queue (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        operation_uuid TEXT NOT NULL UNIQUE,
        module TEXT NOT NULL,
        entity_type TEXT NOT NULL,
        entity_uuid TEXT NOT NULL,
        action TEXT NOT NULL CHECK (action IN ('criar', 'atualizar', 'excluir', 'arquivo')),
        payload_json TEXT NOT NULL,
        dependency_uuid TEXT,
        status TEXT NOT NULL DEFAULT 'pendente' CHECK (status IN ('pendente', 'processando', 'concluida', 'erro', 'conflito')),
        attempts INTEGER NOT NULL DEFAULT 0,
        available_at TEXT NOT NULL,
        last_error TEXT,
        created_at TEXT NOT NULL,
        updated_at TEXT NOT NULL
      );`,
      `CREATE INDEX IF NOT EXISTS idx_sync_queue_dispatch
        ON sync_queue (module, status, available_at, id);`,
      `CREATE INDEX IF NOT EXISTS idx_sync_queue_entity
        ON sync_queue (entity_type, entity_uuid, status);`,
      `CREATE TABLE IF NOT EXISTS sync_state (
        scope TEXT PRIMARY KEY NOT NULL,
        cursor TEXT,
        last_pulled_at TEXT,
        last_pushed_at TEXT,
        updated_at TEXT NOT NULL
      );`,
      `CREATE TABLE IF NOT EXISTS sync_conflicts (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        operation_uuid TEXT NOT NULL,
        module TEXT NOT NULL,
        entity_type TEXT NOT NULL,
        entity_uuid TEXT NOT NULL,
        local_payload_json TEXT,
        server_payload_json TEXT,
        reason TEXT NOT NULL,
        resolved INTEGER NOT NULL DEFAULT 0,
        created_at TEXT NOT NULL,
        resolved_at TEXT
      );`,
      `CREATE INDEX IF NOT EXISTS idx_sync_conflicts_open
        ON sync_conflicts (resolved, module, created_at);`,
      `CREATE TABLE IF NOT EXISTS sync_errors (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        operation_uuid TEXT,
        module TEXT NOT NULL,
        error_code TEXT,
        message TEXT NOT NULL,
        details_json TEXT,
        created_at TEXT NOT NULL
      );`,
      `CREATE INDEX IF NOT EXISTS idx_sync_errors_module
        ON sync_errors (module, created_at);`
    ]
  },
  {
    toVersion: 2,
    statements: [
      `CREATE TABLE IF NOT EXISTS clientes (
        id_cliente INTEGER PRIMARY KEY NOT NULL,
        user_email TEXT NOT NULL,
        user_id INTEGER NOT NULL,
        nome_cliente TEXT NOT NULL,
        signature_pad TEXT,
        nome_cliente_slug TEXT,
        cpf_cliente TEXT,
        cnpj_cliente TEXT,
        razao_social_cliente TEXT,
        email_cliente TEXT,
        assinatura_cliente_url TEXT,
        assinatura_cliente_data TEXT,
        assinatura_cliente_ip TEXT,
        telefone_cliente TEXT,
        celular_cliente TEXT,
        cep_cliente TEXT,
        logradouro_cliente TEXT,
        number_cliente TEXT,
        complemento_cliente TEXT,
        bairro_cliente TEXT,
        cidade_cliente TEXT,
        estado_cliente TEXT,
        desc_cliente TEXT,
        inscricao_estadual_cliente TEXT,
        inscricao_municipal_cliente TEXT,
        pessoa_fisica INTEGER NOT NULL DEFAULT 0,
        pessoa_juridica INTEGER NOT NULL DEFAULT 0,
        create_date TEXT NOT NULL,
        backup_status INTEGER NOT NULL DEFAULT 1,
        status_cliente TEXT NOT NULL DEFAULT 'ativo',
        origem_cliente TEXT,
        observacoes_cliente TEXT,
        data_ultima_interacao TEXT,
        possui_obra_vinculada INTEGER NOT NULL DEFAULT 0,
        obras_liberadas INTEGER NOT NULL DEFAULT 0,
        acesso_obras_ativo INTEGER NOT NULL DEFAULT 0,
        local_updated_at TEXT NOT NULL
      );`,
      `CREATE INDEX IF NOT EXISTS idx_clientes_usuario_nome
        ON clientes (user_id, nome_cliente);`,
      `CREATE INDEX IF NOT EXISTS idx_clientes_usuario_documentos
        ON clientes (user_id, cpf_cliente, cnpj_cliente);`
    ]
  },
  {
    toVersion: 3,
    statements: [
      `CREATE TABLE IF NOT EXISTS obras (
        projeto_id INTEGER PRIMARY KEY NOT NULL,
        imagem_obra TEXT,
        user_email TEXT NOT NULL,
        user_id INTEGER,
        id_cliente INTEGER,
        cliente_nome TEXT,
        projeto_nome TEXT,
        projeto_nome_slug TEXT,
        cep_obra TEXT,
        logradouro_obra TEXT,
        number_obra TEXT,
        complemento_obra TEXT,
        bairro_obra TEXT,
        cidade_obra TEXT,
        estado_obra TEXT,
        projeto_proprietario TEXT,
        projeto_cidade TEXT,
        projeto_endereco TEXT,
        projeto_desc TEXT,
        relatorio_fotografico_descricao TEXT,
        tipo_obra TEXT,
        status_obra TEXT,
        data_prevista_inicio TEXT,
        data_prevista_entrega TEXT,
        valor_contratado TEXT,
        responsavel_obra TEXT,
        projeto_date_create TEXT,
        api_construfacil TEXT NOT NULL,
        local_account_user_id INTEGER NOT NULL,
        permissoes_obra_json TEXT,
        imagem_obra_cache TEXT,
        imagem_obra_url TEXT,
        imagem_obra_servidor TEXT,
        imagem_obra_origem TEXT,
        local_updated_at TEXT NOT NULL
      );`,
      `CREATE INDEX IF NOT EXISTS idx_obras_conta_nome
        ON obras (local_account_user_id, projeto_nome);`,
      `CREATE INDEX IF NOT EXISTS idx_obras_conta_cliente
        ON obras (local_account_user_id, id_cliente, projeto_id);`
    ]
  }
];
